import allLocales from "@fullcalendar/core/locales-all";
import { Calendar } from "fullcalendar";

import { Factory } from "@/data/dao/Factory";
import { DocumentDao } from "@/data/dao/service/DocumentDao";
import { RoomDao } from "@/data/dao/service/RoomDao";
import type { IRoom } from "@/data/model/Room";
import { DateTime } from "@/data/util/DateTime";

import { BaseModal } from "@/shared/elements/BaseModal";
import { logError } from "@/shared/logging/errors";

import { i18n } from "@/portal/Trans";
import { Select } from "@/portal/formControls/Select";
import { TastierGlobal } from "@/portal/globalAccess";

export class DocumentScheduleWindow extends BaseModal {
    private calendar: any;
    private dao: DocumentDao;
    private roomSelector?: Select<IRoom>;

    constructor() {
        super(i18n("modal.documentSchedule.title"), "modal-xl", true);
        this.$element.addClass("documentpreview");

        this.dao = Factory.getInstance<DocumentDao>(DocumentDao);

        const container = $("<div />").appendTo(this.$body);
        this.calendar = new Calendar(container[0], {
            initialView: "dayGridMonth",
            selectable: false,
            aspectRatio: 2.5,
            timeZone: "UTC",
            editable: false,
            locales: allLocales,
            locale: TastierGlobal.getUserLocale(),
            eventClick: (e) => {
                if (e.event.url) {
                    window.open(e.event.url, "_blank");
                    e.jsEvent.preventDefault();
                }

                return false;
            },
            headerToolbar: {
                left: "",
                center: "title",
                right: "dayGridMonth,timeGridWeek,timeGridDay today prev,next",
            },
            events: (info, successCallback, failureCallback) => {
                this.dao
                    .getSchedulePreview({
                        start: DateTime.serializeIsoDate(info.start) as any,
                        end: DateTime.serializeIsoDate(info.end) as any,
                        roomId: this.roomSelector === undefined ? undefined : this.roomSelector.getValue(),
                    })
                    .then((s) => {
                        successCallback(
                            s.map((eventEl) => {
                                return {
                                    title: eventEl.name,
                                    start: eventEl.start,
                                    end: eventEl.end,
                                    url: eventEl.downloadPath,
                                    id: eventEl.id,
                                    allDay: eventEl.isAllDay,
                                };
                            })
                        );
                    })
                    .catch((ex) => {
                        logError(ex);
                        failureCallback(ex);
                    });
            },
        });

        window.setTimeout(() => {
            this.calendar.render();
            const toolBar = container.find(".fc-header-toolbar > .fc-toolbar-chunk:first");
            this.roomSelector = new Select<IRoom>(
                undefined,
                Factory.getInstance(RoomDao),
                (c) => c.name,
                false,
                i18n("modal.documentSchedule.allRooms")
            ).renderTo(toolBar);
            this.roomSelector.onChange = () => this.onRoomChanged();
        }, 200);
    }

    private onRoomChanged() {
        this.calendar.refetchEvents();
    }

    public onShow() {
        this.calendar.updateSize();
    }
}
